/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicQueueStreamQueryParams, GetApiPublicQueueStreamQueryResponse } from "../entities/GetApiPublicQueueStream";
import { z } from "zod/v4";

export const getApiPublicQueueStreamQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiPublicQueueStreamQueryParams>

export const getApiPublicQueueStreamQueryResponseSchema = z.any() as unknown as z.ZodType<GetApiPublicQueueStreamQueryResponse>